import { render, staticRenderFns } from "./ResultText.vue?vue&type=template&id=797d5bc8&scoped=true&lang=pug&"
import script from "./ResultText.vue?vue&type=script&lang=ts&"
export * from "./ResultText.vue?vue&type=script&lang=ts&"
import style0 from "./ResultText.vue?vue&type=style&index=0&id=797d5bc8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d5bc8",
  null
  
)

export default component.exports